// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__aiqgV","link":"style_link__eBEvf","search":"style_search__OI4F7","input":"style_input__ouTUF","icon":"style_icon__OERIr"};